var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { connect } from '@/overmind';
import { hasNewShop } from '@/shared/utils/helpers';
import ShopReborn from '@/modules/shop/components/ShopReborn.vue';
import SmartApproachAppConfig from '@/modules/shop/containers/Apps/SmartApproachAppConfig.vue';
let SmartApproachApp = class SmartApproachApp extends Vue {
    /**
     * Usuário da sessão: currentUser (overmind) é a fonte primária; o fallback
     * cobre o primeiro render antes de o estado hidratar (vue-auth mantém o user
     * em cache).
     */
    get sessionUser() {
        const stateUser = this.currentUser;
        // Sem optional chaining: o ts-loader/webpack desta config nao parseia `?.`
        const auth = Vue.auth;
        const authUser = auth && typeof auth.user === 'function' ? auth.user() : null;
        return stateUser && Object.keys(stateUser).length > 0 ? stateUser : authUser;
    }
    /** Só contas com a flag veem o Shop novo. */
    get hasNewShopModule() {
        return hasNewShop(this.sessionUser);
    }
};
SmartApproachApp = __decorate([
    Component(connect(({ state }) => ({
        currentUser: state.users.currentUser,
    }), {
        name: 'SmartApproachApp',
        components: { ShopReborn, SmartApproachAppConfig },
    }))
], SmartApproachApp);
export default SmartApproachApp;
